import React from 'react';
import classes from '../RelatedRooms.module.scss';
import { availableIconFormat, documnentIcons } from 'helpers/documentIcons';
import { IDocument } from 'interfaces';
import { CheckOutlined, EyeOutlined, SignatureFilled } from '@ant-design/icons';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

type ReferrinRoomRowTypes = {
  document: IDocument;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedTerm: React.Dispatch<React.SetStateAction<IDocument | null>>;
  
}

const ReferrinRoomRow = ({ document, setIsOpen, setSelectedTerm }: ReferrinRoomRowTypes) => {
  const { t } = useTranslation();

  const formatNDA = document.name?.split('.')?.reverse()[0];  
  const icon = availableIconFormat.includes(formatNDA) ? formatNDA : 'default';

  const openTermInModal = () => {
    setIsOpen(true);
    setSelectedTerm({
      ...document,
      user_status: {status_access: 'accepted'}
    });
  }

  return (
    <div className={cn(classes.uploadedWrap, classes.cantEdit)}>
      <div className={classes.roomName}>{document?.room?.name}</div>
      <div onClick={openTermInModal} className={classes.card}>
        <div style={{display: 'flex', alignItems:'center'}}>
          <div style={{ fontSize: 32 }}>{documnentIcons[icon as keyof typeof documnentIcons]}</div>
          <div className={classes.docCardName}>{document?.name}</div>
        </div>

        <div
          onClick={openTermInModal}
          className={classes.cardView}
        >
          {document.status === 0 ? <SignatureFilled /> : <EyeOutlined />}
        </div>

      </div>

      <div className={classes.statusTermWrap}>
        <CheckOutlined className={classes.acceptIcon}/>
        <span className={classes.accept}>{t('Settings.terms.state.accepted')}</span>
      </div>

    </div>
  );
}

export default ReferrinRoomRow;
